import { render, staticRenderFns } from "./TicketPDF.vue?vue&type=template&id=a0cbb4aa&"
import script from "./TicketPDF.vue?vue&type=script&lang=js&"
export * from "./TicketPDF.vue?vue&type=script&lang=js&"
import style0 from "./TicketPDF.vue?vue&type=style&index=0&id=a0cbb4aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports